import { tns } from "tiny-slider";
import { observeImages } from "./_lazy-image";
import { observeNextDepartureElements } from "./_next-departures";

function initDestinationCarousel(id) {
	tns({
		container: ".destination-carousel-container-" + id,
		mode: "carousel",
		items: 1,
		gutter: 24,
		loop: true,
		autoplay: false,
		controlsContainer: ".destinationControls-" + id,
		prevButton: ".destination-previous-" + id,
		nextButton: ".destination-next-" + id,
		navPosition: "bottom",
		lazyload: false,
		responsive: {
			900: {
				gutter: 42,
				items: 2,
			},
		},
	});

	const images = document.querySelectorAll(
		`.destination-carousel-container-${id} img.lazy`
	);
	observeImages(images);
	const nextDepartureElements = document.querySelectorAll(
		`.destination-carousel-container-${id} .next-departure-container`
	);
	observeNextDepartureElements(nextDepartureElements);
}

window.initDestinationCarousel = initDestinationCarousel;
